import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

/**
 * Service to start End2End bingo game via the standard GameInit endpoint.
 * @param {string} currency - The currency to use (default: VES)
 * @returns {Promise} API response with game URL
 */
export const startEnd2EndBingoGameService = async (currency = "VES") => {
  return privateRequest.get(`${ConfEnv.BASE_URL}/games/init/end2end/lobby?currency=${currency}`);
};
